import React from "react";
import SvgBookmarkIcon from "../icons/iconComponents/BookmarkIcon";
import bookmarkPlusIcon from "../icons/bookmark-plus.svg";
import bookmarkCheckIcon from "../icons/bookmark-check.svg";
import bookmarkIcon from "../icons/bookmarkIcon.svg";
import "./ToggleBookmark.css";
import {
	createRefetchContainer,
	createFragmentContainer,
	graphql
} from "react-relay";
import DeleteBookmarkMutation from "../mutations/DeleteBookmarkMutation";
import AddBookmarkMutation from "../mutations/AddBookmarkMutation";

function ToggleBookmark(props) {
	const user_Bookmark = props.user_Bookmark;
	const postId = props.postId;

	let postIdInt = atob(postId)
		.split(":")
		.pop();

	function onFillBookmarkClick(e) {
		e.preventDefault();

		let bookmarkId = e.target.dataset.id;

		// let bookmarkIdInt = atob(bookmarkId)
		// 	.split(":")
		// 	.pop();

		DeleteBookmarkMutation(postId, bookmarkId, () => {
			// console.log("Deleted Bookmark!");
		});
	}

	function onBookmarkClick(e) {
		e.preventDefault();
		AddBookmarkMutation(postId, postIdInt, () => {
			// console.log("Added a new Bookmark");
		});
	}

	return (
		<div className={`toggle-bookmark-icon-container`}>
			{user_Bookmark.simpleBookmark.edges.length != 0 ? (
				user_Bookmark.simpleBookmark.edges.map((edge, key) => (
					<div key={key}>
						<img
							style={{ margin: 0, padding: 0 }}
							key={key}
							width={24}
							src={bookmarkCheckIcon}
							data-id={edge.node.id}
							onClick={onFillBookmarkClick}
							alt=""
						/>
					</div>
				))
			) : (
				<div>
					<img
						style={{ margin: 0, padding: 0 }}
						width={24}
						src={bookmarkPlusIcon}
						onClick={onBookmarkClick}
						alt=""
					/>
				</div>
			)}
		</div>
	);
}

export default createRefetchContainer(ToggleBookmark, {
	user_Bookmark: graphql`
		fragment ToggleBookmark_user_Bookmark on PostNode
			@argumentDefinitions(post: { type: "ID" }) {
			simpleBookmark(post: $post, first: 1)
				@connection(key: "Bookmark_simpleBookmark", filters: []) {
				edges {
					node {
						id
						is_bookmarked
					}
				}
			}
		}
	`
});
